<template>
  <input
    type="text"
    class="form-control"
    v-model="value"
    :autocomplete="schema.autocomplete"
    :disabled="disabled"
    :placeholder="schema.placeholder"
    :readonly="schema.readonly"
    :name="schema.inputName"
    :id="getFieldID(schema)"
  />
</template>

<script>
import { abstractField } from "vue-form-generator";
import Inputmask from "inputmask";

Inputmask.extendAliases({
  number: {
    alias: "numeric",
    groupSeparator: " ",
    autoGroup: true,
    autoUnmask: true,
    digits: 2,
    radixPoint: ",",
    // digitsOptional: false,
    removeMaskOnSubmit: true,
    clearMaskOnLostFocus: false
  }
});

export default {
  mixins: [abstractField],
  mounted() {
    this.$nextTick(function() {
      Inputmask().mask(this.$el);
      if (this.schema.mask) {
        Inputmask(this.schema.mask, this.schema.maskOptions).mask(this.$el);
      } else if (this.schema.alias) {
        Inputmask(this.schema.alias, this.schema.maskOptions).mask(this.$el);
      }
    });
  },
  beforeDestroy() {
    Inputmask().mask(this.$el);
  }
};
</script>
